export class LotNumberParamsModel {
    public formatId: number = null;
    public vcpId: number = null;
    public lotNumber: string = "";
}
